<script>
  import TrendIndicator from './TrendIndicator.svelte';

  export let capacity = 0;
  export let size = 'base';
  export let trend = null;
  export let previousCapacity = null;
  export let label = '';
  export let showLabel = true;
  export let showTrend = true;
  export let showValue = false;

  const labels = {
    1: 'Nascent capacity',
    2: 'Limited capacity',
    3: 'Moderate capacity',
    4: 'Well-developed capacity',
    5: 'Sustainable capacity'
  };

  const allowedSizes = ['sm', 'base', 'lg', '2xl'];
  const allowedTrends = ['na', 'up', 'down', 'flat'];

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  $: resolvedCapacity = clamp(capacity, 1, 5);
  $: resolvedSize = allowedSizes.includes(size) ? size : 'base';
  $: resolvedLabel = label || labels[Math.ceil(resolvedCapacity)];
  $: hasPreviousCapacity = previousCapacity != null && previousCapacity !== '';
  $: resolvedPreviousCapacity = hasPreviousCapacity
    ? clamp(previousCapacity, 1, 5)
    : null;
  $: calculatedTrend = !hasPreviousCapacity
    ? 'na'
    : capacity > previousCapacity
    ? 'up'
    : capacity < previousCapacity
      ? 'down'
      : 'flat';
  $: resolvedTrend = allowedTrends.includes(trend) ? trend : calculatedTrend;
  $: resolvedCurrentPercent = resolvedCapacity * 20;
  $: resolvedPreviousPercent = hasPreviousCapacity ? resolvedPreviousCapacity * 20 : 0;
  
  $: resolvedVariation = hasPreviousCapacity
  ? Number((resolvedCapacity - resolvedPreviousCapacity).toFixed(1))
  : '';
  $: cssVars = `--capacity-level-bar-fill: ${resolvedCurrentPercent}%; --capacity-level-bar-previous: ${resolvedPreviousPercent}%;`;
</script>

<div
  class="capacity-level-bar"
  data-capacity={Math.ceil(capacity)}
  data-previousCapacity={hasPreviousCapacity ? Math.ceil(previousCapacity) : undefined}
  data-has-previous-capacity={hasPreviousCapacity}
  data-size={resolvedSize}
  data-trend={resolvedTrend || undefined}
  style={cssVars}
>
  {#if showValue}
    <p class="capacity-level-bar__value">{resolvedCapacity} <small>{#if resolvedTrend=='up'}+{/if}{#if resolvedTrend=='flat'}±{/if}{resolvedVariation}</small></p>
  {/if}
  <div class="capacity-level-bar__main">
    <div class="capacity-level-bar__bars">
      <div class="capacity-level-bar__fill"></div>
      {#if hasPreviousCapacity}
        <div class="capacity-level-bar__reference"></div>
      {/if}
    </div>

    {#if showTrend && resolvedTrend}
      <TrendIndicator trend={resolvedTrend} size={resolvedSize} />
    {/if}
  </div>

  {#if showLabel && resolvedLabel}
    <p class="capacity-level-bar__label">{resolvedLabel}</p>
  {/if}
</div>
